import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Action from '../actions';
import {connect} from 'react-redux';

class CheckAllLineups extends Component {
    onCheck(isChecked) {
        this.props.dispatch(Action.do('checkAllLineups', isChecked));
    }

    render() {
        const {sportConfig, filters} = this.props;

        if (sportConfig.isModeLateswap()) {
            return null;
        }

        return (
            <div className="lineup-control">
                <label>Select lineups:</label>
                <div className="lineup-control-holder">
                    <div className="filter-btn-group">
                        <button
                            type="button"
                            className={filters.isLineupsListChecked() ? 'active' : ''}
                            onClick={(e) => ::this.onCheck(true)}
                        >
                            ALL
                        </button>
                        <button
                            type="button"
                            className={!filters.isLineupsListChecked() ? 'active' : ''}
                            onClick={(e) => ::this.onCheck(false)}
                        >
                            NONE
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        lineupsData: {filters},
    } = state;

    return {
        sportConfig,
        filters,
    };
}

export default connect(mapStatesToProps)(CheckAllLineups);
